import React, { FC, ReactNode } from 'react';
import { Radio } from 'antd';
import { IMenuItem } from 'entities/Menu/Menu.models';
import { MenuItemImage } from 'entities/Menu/components/MenuItemImage';

interface IComponentProps {
  title: ReactNode;
  items: IMenuItem[];
  selectedId?: string;
  isOptional?: boolean;
  // Resolves the price shown next to each option. For an included combo component this is the
  // delta vs the default (default → +0); for "Make it a Meal!" it is the full menu price.
  getPrice?: (item: IMenuItem) => number;
  onChange: (menuItemId: string) => void;
  onDeselect?: () => void;
}

const formatPrice = (price: number): string => `${price < 0 ? '- P' : '+ P'}${Math.abs(price)}`;

export const MealBuilderPicksList: FC<IComponentProps> = ({
  title,
  items,
  selectedId,
  isOptional = false,
  getPrice = (item) => item.mealBuilderPrice ?? 0,
  onChange,
  onDeselect,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <div className="menu-details__meal-builder-section">
      <div className="menu-details__meal-builder-title">{title}</div>
      <Radio.Group
        className="menu-details__meal-builder-radio-group"
        value={selectedId}
        onChange={(e) => onChange(e.target.value as string)}
      >
        {items.map((item) => {
          const isUnavailable = item.isEnable === false;

          return (
            <Radio
              key={item.menuItemId}
              value={item.menuItemId}
              disabled={isUnavailable}
              className="menu-details__meal-builder-option"
              onClick={() => isOptional && !isUnavailable && item.menuItemId === selectedId && onDeselect?.()}
            >
              <div className="menu-card__row">
                <div className="menu-card__row-left">
                  <div className={`menu-card__row-image${!item.image ? ' menu-card__row-image_placeholder' : ''}`}>
                    {item.image && (
                      <MenuItemImage src={item.image} className="menu-card__image" alt={item.name} width={44} height={44} />
                    )}
                  </div>
                  <div className="menu-card__row-title">
                    <span className="menu-card__header">{item.name}</span>
                    {isUnavailable ? (
                      <span className="fs-xxs color-gray">Temporarily unavailable</span>
                    ) : (
                      <span className="fs-xxs color-gray">{formatPrice(getPrice(item))}</span>
                    )}
                  </div>
                </div>
              </div>
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};
